import { useEffect } from "react";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";

import { Card } from "@icg360/design-system";

import { AppLoaderData } from "../../types";
import styles from "./LiftLock.module.css";
import { LiftLockSuccess } from "./LiftLockSuccess";
import { usePaymentIntentStatus } from "./usePaymentIntentStatus";

export const LiftLockReturn = () => {
  const navigate = useNavigate();
  const { proposal } = useParams();
  const {
    quote: { roofResealingStripeIntentClientSecret }
  } = useRouteLoaderData<AppLoaderData>("root")!;

  const status = usePaymentIntentStatus(
    roofResealingStripeIntentClientSecret ?? ""
  );

  useEffect(() => {
    if (!status) {
      return;
    }
    if (["requires_action", "requires_payment_method"].includes(status)) {
      // back to the form
      void navigate(`/${proposal}/liftlock`);
    } else if (["canceled", "no_intent"].includes(status)) {
      // back to the quote
      void navigate(`/${proposal}`);
    }
  }, [navigate, proposal, status]);

  return status === "succeeded" || status === "processing" ? (
    <LiftLockSuccess />
  ) : (
    <div className={styles.container}>
      <Card className={styles.returnCard}>
        <div>{status}</div>
      </Card>
    </div>
  );
};
